import Profile from '../components/Profile/Profile'
import Edit from '../components/Profile/Edit'

let routes = {
    path: '/profile',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/profile',
            name: 'Profile',
            component: Profile
        },
        {
            path: '/profile/edit',
            name: 'Profile Edit',
            component: Edit
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/profile.js